import React, { useState } from 'react';
import styles from '../Styles/DiagnosticAPage.module.css';
import axios from 'axios';
import { useDiagnostico } from './../../../context/DiagnosticoContext/DiagnosticoHook';
// import convertHTMLToPDF  from 'pdf-puppeteer';
// Apply autoTable plugin to jsPDF

function EndOfDiagnostic({ respuestasDB }) {
  const [nombre, setNombre] = useState('');
  const [empresa, setEmpresa] = useState('');
  const [email, setEmail] = useState('');
  const [telefono, setTelefono] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { chartCaptures, changeStateEndOfDiagnosticFn, idQuestions } =
    useDiagnostico();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const dataOfUser = {
      company: empresa,
      name: nombre,
      email: email,
      cel: telefono,
    };
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/pdfDiagnostic/generatePdfDiagnosticA`,
      {
        idRef: idQuestions,
        captures: chartCaptures,
        dataOfUser: { ...dataOfUser },
        nameTemplate: 'diagnosticPrototype1.html',
      },
    );
    if (res.status === 200) {
      changeStateEndOfDiagnosticFn(true);
      setIsLoading(false);
    }
  };

  return (
    <div className="formulario-datos-container">
      <div className="formulario-datos">
        <h2>¡Felicidades! Has completado tu evaluación.</h2>
        <p className="mensaje">
          Te encuentras entre las <b>{respuestasDB.length}</b> empresas
          visionarias que ya están cambiando su futuro digital.
        </p>{' '}
        <p>
          Nuestro compromiso es ayudar a fortalecer el tejido económico,
          brindando las herramientas necesarias para sobresalir en la era
          digital.
        </p>{' '}
        <p>
          Te enviaremos un informe con recomendaciones específicas para mejorar
          la madurez digital de tu empresa.
        </p>{' '}
        <p>
          Sólo necesitamos algunos detalles para personalizar tu informe. Por
          favor, déjanos tus datos a continuación y prepárate para liderar el
          cambio digital.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              placeholder="Nombre de la empresa"
              id="empresa"
              type="text"
              value={empresa}
              onChange={(e) => setEmpresa(e.target.value)}
              required
            />
          </div>
          <div className="input-group">
            <input
              placeholder="Tu nombre"
              id="nombre"
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              required
            />
          </div>
          <div className="input-group">
            <input
              placeholder="Correo electrónico"
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="input-group">
            <input
              placeholder="WhatsApp"
              id="telefono"
              type="tel"
              value={telefono}
              onChange={(e) => setTelefono(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            className="btn-enviar btn btn-primary btn-comenzar"
            disabled={isLoading}
          >
            {isLoading ? 'Enviando...' : 'Enviar'}
          </button>
          <span className={styles.tyc}>
            Al hacer clic en &quot;Enviar&quot;, confirmas que has leído y
            aceptas nuestros{' '}
            <a
              target="_blank"
              href="https://growtty.com/terminos-y-condiciones/"
              className={{ textDecoration: 'underline' }}
              rel="noreferrer"
            >
              Términos y Condiciones
            </a>{' '}
            y{' '}
            <a
              target="_blank"
              href="https://growtty.com/politicas-de-privacidad/"
              className={{ textDecoration: 'underline' }}
              rel="noreferrer"
            >
              Política de Privacidad
            </a>
            .
          </span>
        </form>
      </div>
    </div>
  );
}

export default EndOfDiagnostic;
